
"use client";

import AfinaMatch from "../AfinaMatch";

export default function AfinaMatchLeagues({ league, matches = [] }) {
  const { name, nameVN } = league || {};

  return (
    <div className="w-full overflow-hidden">
      <div className="afina-league-header shrink-0 px-2 py-1.5 text-sm font-medium">
        {`Kèo bóng đá ${nameVN || name}`}
      </div>
      <div className="flex flex-col gap-0.5">
        {matches.map((match, index) => (
          <AfinaMatch key={match.id} match={match} index={index} />
        ))}
      </div>
    </div>
  );
}
